import React from 'react';

import './hev.css';

const Hev = () => {
    return (
        <main>
            <h1>Хэвлэл мэдээллийн алба</h1>
        </main>
    )
}
export default Hev;